module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="form-group row">\n	';
 if (projection) {;
__p += '\n	<label class="DescartesUILabel col-md-4 col-lg-4 col-form-label">\n		Projection\n	</label>\n	<div class="col-md-8 col-lg-8">\n		';
 if (projectionsCodesValues.length === 1) {;
__p += '\n			<label  class="DescartesUILabel col-form-label">' +
((__t = (projectionsCodesValues[0].value)) == null ? '' : __t) +
'</label>\n		';
} else {;
__p += '\n    		<select class="DescartesUISelect form-control" name="coordinatesproj" id="coordinatesproj">\n            	';
 for (var i = 0, len = projectionsCodesValues.length; i < len; i++) { ;
__p += '\n    				<option value="' +
((__t = (projectionsCodesValues[i].code)) == null ? '' : __t) +
'" \n    				';
 if (selectedProjection === i) { ;
__p += '\n    				selected >' +
((__t = (projectionsCodesValues[i].value)) == null ? '' : __t) +
'</option>\n    				';
} else {;
__p += '\n    					>' +
((__t = (projectionsCodesValues[i].value)) == null ? '' : __t) +
'</option>\n        			';
};
__p += '\n    			';
};
__p += '\n			</select>\n    	';
 };
__p += '\n    </div>	\n    ';
};
__p += '\n</div>\n<div class="form-group row">\n    <label id="coordinates_input_x" for="' +
((__t = (id)) == null ? '' : __t) +
'_input_x" class="DescartesUILabel col-sm-3 col-form-label">' +
((__t = (x)) == null ? '' : __t) +
'</label>\n    <div class="col-sm-9">\n        <input type="text" step="any" required="true" class="DescartesUIInput form-control" id="' +
((__t = (id)) == null ? '' : __t) +
'_input_x" name="x">\n    </div>\n</div>\n<div class="form-group row">\n    <label id="coordinates_input_y" for="' +
((__t = (id)) == null ? '' : __t) +
'_input_y" class="DescartesUILabel col-sm-3 col-form-label">' +
((__t = (y)) == null ? '' : __t) +
'</label>\n    <div class="col-sm-9">\n        <input type="text" step="any" required="true" class="DescartesUIInput form-control" id="' +
((__t = (id)) == null ? '' : __t) +
'_input_y" name="y">\n    </div>\n</div>\n\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/DMap/UI/bootstrap4/templates/CoordinatesInputDialog.ejs
// module id = 420
// module chunks = 0